import {defaultState} from "./state";
import { PRODUCT_FILTER } from "@/contants/productAssignment";

const removeFromList = (list, id) => {
  list.splice(list.indexOf(id), 1);
}

const mutations = {
  SET_EXPAND_LIST: (state, { filter, id }) => {
    const expandedList = state.product[filter].expandedList;
    const isExpanded = expandedList.includes(id);
    if (isExpanded) {
      return removeFromList(expandedList, id);
    }
    expandedList.push(id);
  },
  SET_PAGE_ID: (state, pageId) => {
    state.product.pageId = pageId;
  },
  SET_SEARCH_BY: (state, searchByVal) => {
    state.searchBy = searchByVal;
  },
  SET_FETCHED_ALL: (state, type) => {
    state.product[type].fetched = true;
  },
  SET_FETCHED_ALL_QUERY: (state, type) => {
    state.product[type].queryFetched = true;
  },
  SET_ASSIGNED_PRODUCT: (state, productId) => {
    const { assigned, selected } = state.product.assignment;
    const isNotAssigned = !assigned.includes(productId);
    const isNotSelected = !selected.includes(productId);
    if (isNotAssigned) assigned.push(productId);
    if (isNotSelected) selected.push(productId);
  },
  UPDATE_ASSIGNED_PRODUCT: (state, productId) => {
    const { assigned, selected, unselected } = state.product.assignment;
    const isAssigned = assigned.includes(productId);
    const isSelected = selected.includes(productId);
    
    if (isSelected) {
      if (isAssigned) unselected.push(productId);
      return removeFromList(selected, productId);
    }
    
    if (isAssigned) {
      removeFromList(unselected, productId);
    }
    
    selected.push(productId);
  },
  SET_SELECT_ALL: (state, productList) => {
    const { assigned, selected, unselected } = state.product.assignment;
    const listId = productList.map((product) => product.id);
    const isNotSelectAll = !listId.every(id => selected.includes(id));
    
    listId.map(id => {
      const isSelected = selected.includes(id);
      const isAssigned = assigned.includes(id);

      if (isSelected) {
        if (isNotSelectAll) return;
        if (isAssigned) unselected.push(id);
        return removeFromList(selected, id);
      }
      
      if (isAssigned) {
        removeFromList(unselected, id);
      }

      selected.push(id);
    });
  },
  RESET_SEARCH_RESULT: (state) => {
    for (const item in PRODUCT_FILTER) {
      const filter = PRODUCT_FILTER[item];
      state.product[filter].queryList = [];
      state.product[filter].queryFetched = false;
      state.product[filter].endCursorQuery = ''
    }
  },
  RESET_SELECT_PRODUCT: (state) => {
    state.product.assignment.selected = [];
    state.product.assignment.unselected = [];
  },
  RESET_SELECT_BY_FILTER: (state, selectedByFilter) => {
    const toRemove = new Set(selectedByFilter);
    state.product.assignment.selected = state.product.assignment.selected.filter(
      id => !toRemove.has(id)
    );
  },
  RESET_PRODUCT_DATA: (state) => {
    return Object.assign(state, defaultState());
  },
  REFRESH_PRODUCT_DATA: (state) => {
    state.assignedOnly = true;
    state.assignedOnlyQuery = true;
    state.product.assignment.assigned = [];
    state.product.assignment.selected = [];
    state.product.assignment.unselected = [];
    for (const item in PRODUCT_FILTER) {
      const filter = PRODUCT_FILTER[item];
      state.product[filter].list = [],
      state.product[filter].products = [],
      state.product[filter].fetched = false,
      state.product[filter].endCursor = '',
      state.product[filter].expandedList = []
    }
  },
  REFRESH_PRODUCT_QUERY_DATA: (state) => {
    state.assignedOnly = true;
    state.assignedOnlyQuery = true;
    state.product.assignment.assigned = [];
    state.product.assignment.selected = [];
    state.product.assignment.unselected = [];
    for (const item in PRODUCT_FILTER) {
      const filter = PRODUCT_FILTER[item];
      state.product[filter].queryList = [],
      state.product[filter].products = [],
      state.product[filter].queryFetched = false,
      state.product[filter].endCursorQuery = '',
      state.product[filter].expandedList = []
    }
  }
};
export default mutations;
